import { useEffect, useRef, useState } from "react";
import {
  RunnerEvent,
  runnerEventListWithRandom,
  runnerEventRatio,
} from "../../../../../api/event";
import { AdBannerArrow, AdBannerWrapper, AdCardItemWrapper } from "./styles";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Swiper as SwiperType } from "swiper";
import { openNewWindow } from "../../../../../utils/common";
import { useHistory } from "react-router-dom";

const AdBanner = () => {
  const [list, setList] = useState<RunnerEvent[]>([]);
  const [currenBannerIndex, setCurrentBannerIndex] = useState(0);
  const swiperRef = useRef<SwiperType | null>(null);
  const history = useHistory();
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    runnerEventRatio().then((res) => {
      setWidth(res.width);
      setHeight(res.height);
    });
  }, []);

  const getData = () => {
    runnerEventListWithRandom({ endYn: "N", type: "MAIN" })
      .then((res) => {
        setList(res);
      })
      .catch((e: any) => {
        console.error(e);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getData();
  }, []);

  // 배너 이미지 이동 함수
  const handleCurrentIndex = (offset: number) => {
    if (list?.length === 0) return;

    const total = list.length;
    let newIndex = currenBannerIndex + offset;

    if (newIndex < 0) newIndex = 0;
    if (newIndex > total - 1) newIndex = total - 1;

    setCurrentBannerIndex(newIndex);
    // 해당 index로 이동
    swiperRef.current?.slideTo(newIndex);
  };

  if (list.length === 0) return <></>;
  return (
    <AdBannerWrapper width={width} height={height}>
      <Swiper
        className="banner-swiper"
        onRealIndexChange={(swiper: any) =>
          setCurrentBannerIndex(swiper.realIndex || 0)
        }
        onSwiper={(swiper: SwiperType) => (swiperRef.current = swiper)}
        slidesPerView={1}
        centeredSlides={true}
        autoplay={{ delay: 2000 }}
        modules={[Autoplay]}
      >
        {list.map((item, index) => (
          <SwiperSlide>
            <AdCardItemWrapper
              key={index}
              width={width}
              height={height}
              onClick={() => {
                if (item.link.includes("http")) {
                  openNewWindow(item.link);
                } else {
                  history.push(item.link);
                }
              }}
            >
              <img src={item.url} alt={item.title} />
            </AdCardItemWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
      {currenBannerIndex !== 0 && (
        <AdBannerArrow isLeft={true} onClick={() => handleCurrentIndex(-1)}>
          <img alt="left" src="/image-web/store/Btn/arrow-left.svg" />
        </AdBannerArrow>
      )}
      {currenBannerIndex !== list.length - 1 && (
        <AdBannerArrow isLeft={false} onClick={() => handleCurrentIndex(1)}>
          <img alt="right" src="/image-web/store/Btn/arrow-right.svg" />
        </AdBannerArrow>
      )}
    </AdBannerWrapper>
  );
};

export default AdBanner;
